<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-row :span="2" style="margin-top: 30px;">
              名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              图片:<el-input v-model="img" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>
           

          <el-row :span="2" style="margin-top: 30px;">
              <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
          </el-row>
      </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="100"
              label="名称"
               >
               <template slot-scope="scope">
                   <div  @click="to(scope.row.id)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
			<el-table-column
			
			  width="80"
			  label="标签"
			   >
			  <template slot-scope="scope">
			
			    <div>{{scope.row.lables}}</div>
				<div @click="dischange(scope.row.lables,scope.row.id,8)" style="color: #409eff;font-size: 24px;margin-top: 15px;">修改标签</div>
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="80"
			  label="中文名字"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.namech,scope.row.id,2)">{{scope.row.namech}}</div>
				<div @click="guanli(scope.row.id)" style="color: #409eff;font-size: 24px;margin-top: 15px;">添加拼音</div>
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="80"
			  label="中文拼音"
			   >
			  <template slot-scope="scope">			
			    <div>{{scope.row.namepy}}</div>				
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="80"
			  label="排序"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.orders,scope.row.id,3)">{{scope.row.orders}}</div>
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="80"
			  label="检查OK"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.check,scope.row.id,4)">{{scope.row.check}}</div>
			  </template>
			</el-table-column>
			<el-table-column
			
			  width="150"
			  label="apmg"
			   >
			  <template slot-scope="scope">
			
			    <div  @click="dischange(scope.row.apmg,scope.row.id,9)">{{scope.row.apmg}}</div>
			  </template>
			</el-table-column>
            <el-table-column
            
              width="150"
              label="gif图片地址"
               >
              <template slot-scope="scope">
            
                <div  @click="dischange(scope.row.img,scope.row.id,5)">{{scope.row.img}}</div>
              </template>
            </el-table-column>
            <el-table-column

              width="100"
              label="gif图片"
               >
              <template slot-scope="scope">

                <img style="width: 60px;height: 60px;"  :src="scope.row.img" class="avatar">
              </template>
            </el-table-column>
				<el-table-column
				
				  width="150"
				  label="静态图片地址"
				   >
				  <template slot-scope="scope">
				
				    <div  @click="dischange(scope.row.imgj,scope.row.id,7)">{{scope.row.imgj}}</div>
				  </template>
				</el-table-column>
				<el-table-column
				
				  width="100"
				  label="静态图片"
				   >
				  <template slot-scope="scope">
				
				    <img style="width: 60px;height: 60px;"  :src="scope.row.imgj" class="avatar">
				  </template>
				</el-table-column>		
				<el-table-column
				
				  width="80"
				  label="MP4地址"
				   >
				  <template slot-scope="scope">
				
				    <div  @click="dischange(scope.row.video,scope.row.id,6)">{{scope.row.video}}</div>
				  </template>
				</el-table-column>
			
            <el-table-column

              width="280"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>
				   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="dischange(scope.row.name,scope.row.id,1)">修改名称</el-col>	
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="$refs.directionImageDialog.open(scope.row.id, 8)">八向图</el-col>
                 </el-row>
               </template>
            </el-table-column>
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
		<el-dialog
		    title="添加名称"
		    :visible.sync="disDialogVisiblehy"
		    width="20%"
		    center>
		    
		    <!-- <input type="text" style="width: 50%;height: 30px;padding-left: 5px;"  v-model="names"/> -->
		    <el-input
		      type="textarea"
		      :rows="30"
		      placeholder="请输入内容"
		      v-model="textarea">
		    </el-input>
		    <span slot="footer" class="dialog-footer">
		    <el-button @click="disDialogVisiblehy = false">取 消</el-button>
		    <el-button type="primary" @click="doAddHy()">确 定</el-button>
		    </span>
		</el-dialog>
		<el-dialog
		  title="管理"
		  :visible.sync="dialogVisiblegl"
		  width="30%"
		  >
				<el-button type="primary" style="background-color: #409eff;margin-top: 5px;margin-bottom: 5px;" @click="addhy()">添加名称</el-button>
				
		  <el-table
		      :data="lists"
		      height="600"
		      border
		      style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
		  <el-table-column              
		    width="300"
		    label="名称"
		     >
		     <template slot-scope="scope">
		         <div>{{scope.row.name}}</div>
		     </template>
		  </el-table-column>   		     
		  <el-table-column              
		    width="200"
		    label="操作"
		     >
		     <template slot-scope="scope">
		       <el-row>
		         <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="delh(scope.row.id)">删除</el-col>
		  		
		        
		       </el-row>
		     </template>
		  </el-table-column>
		  </el-table>
		</el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
	<el-dialog
	  title="修改旋转帧"
	  :visible.sync="xuanzhuanC"
	  width="30%"
	  center>
	  <input type="text" class="searchT" v-model="xuan_name"/>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="xuanzhuanC = false">取 消</el-button>
		<el-button type="primary" @click="dodischangeXuan()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="旋转帧"
	  :visible.sync="xuanzhuan"
	  width="40%"
	  center>
	  <el-row :span="2" style="margin-top: 30px;margin-bottom: 20px;">
	      <el-col :span="4">
			  id:<el-input v-model="xuan_id" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  left:<el-input v-model="xuan_left" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  right:<el-input v-model="xuan_right" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  yiban:<el-input v-model="xuan_yiban" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  <el-button type="primary" style="background-color: #409eff;" @click="addXuan()" round>添加</el-button>
		  </el-col>
	  </el-row>
	  <template>
	    <el-table
	  	:data="xuanzhuanList"
	    height="400"
	  	border
	  	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
	    <el-table-column
	  
	      width="100"
	      label="id"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeXuan(scope.row.id,scope.row.ids,1)">{{scope.row.id}}</div>
	       </template>
	    </el-table-column>
	    <el-table-column
	    	  
	      width="100"
	      label="left"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeXuan(scope.row.left,scope.row.ids,2)">{{scope.row.left}}</div>
	       </template>
	    </el-table-column>
		<el-table-column			  
		  width="100"
		  label="right"
		   >
		   <template slot-scope="scope">
		       <div  @click="dischangeXuan(scope.row.right,scope.row.ids,3)">{{scope.row.right}}</div>
		   </template>
		</el-table-column>
		<el-table-column			  
		  width="100"
		  label="yiban"
		   >
		   <template slot-scope="scope">
		       <div  @click="dischangeXuan(scope.row.yiban,scope.row.ids,4)">{{scope.row.yiban}}</div>
		   </template>
		</el-table-column>
		<el-table-column
			width="200"
			label="操作"
		>
		   <template slot-scope="scope">
			 <el-row>
			   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="xuanDel(scope.row.ids,scope.$index)">删除</el-col>				
			 </el-row>
		   </template>
		</el-table-column>
	</el-table>
	</template>
	  			
				
	   
	</el-dialog>
	
	
	<el-dialog
	  title="修改移动速度"
	  :visible.sync="yidongsuduC"
	  width="30%"
	  center>
	  <input type="text" class="searchT" v-model="yidong_name"/>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="yidongsuduC = false">取 消</el-button>
		<el-button type="primary" @click="dodischangeYidong()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="移动速度"
	  :visible.sync="yidongsudu"
	  width="40%"
	  center>
	  <el-row :span="2" style="margin-top: 30px;margin-bottom: 20px;">
	      <el-col :span="4">
			  id:<el-input v-model="yidong_id" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  sudu:<el-input v-model="yidong_sudu" style="width: 100px;"></el-input>
		  </el-col>		   
		  <el-col :span="4">
		  	  <el-button type="primary" style="background-color: #409eff;" @click="addYidong()" round>添加</el-button>
		  </el-col>
	  </el-row>
	  <template>
	    <el-table
	  	:data="yidongList"
	    height="400"
	  	border
	  	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
	    <el-table-column
	  
	      width="100"
	      label="id"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeYidong(scope.row.id,scope.row.ids,1)">{{scope.row.id}}</div>
	       </template>
	    </el-table-column>
	    <el-table-column
	    	  
	      width="100"
	      label="sudu"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeYidong(scope.row.sudu,scope.row.ids,2)">{{scope.row.sudu}}</div>
	       </template>
	    </el-table-column>
		
		<el-table-column
			width="200"
			label="操作"
		>
		   <template slot-scope="scope">
			 <el-row>
			   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="yidongDel(scope.row.ids,scope.$index)">删除</el-col>				
			 </el-row>
		   </template>
		</el-table-column>
	</el-table>
	</template>
	  			
				
	   
	</el-dialog>
	
	
	<el-dialog
	  :title="zuobiao_title"
	  :visible.sync="zuobiaoC"
	  width="30%"
	  center>
	  <input type="text" class="searchT" v-model="zuobiao_name"/>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="zuobiaoC = false">取 消</el-button>
		<el-button type="primary" @click="dodischangeZuobiao()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  :title="zuobiao_title"
	  :visible.sync="zuobiao"
	  width="40%"
	  center>
	  <el-row :span="2" style="margin-top: 30px;margin-bottom: 20px;">
	      <el-col :span="4">
			  id:<el-input v-model="zuobiao_id" style="width: 100px;"></el-input>
		  </el-col>
		  <el-col :span="4">
		  	  value:<el-input v-model="zuobiao_value" style="width: 100px;"></el-input>
		  </el-col>		   
		  <el-col :span="4">
		  	  <el-button type="primary" style="background-color: #409eff;" @click="addZuobiao()" round>添加</el-button>
		  </el-col>
	  </el-row>
	  <template>
	    <el-table
	  	:data="zuobiaoList"
	    height="400"
	  	border
	  	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
	    <el-table-column
	  
	      width="100"
	      label="id"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeZuobiao(scope.row.id,scope.row.ids,1)">{{scope.row.id}}</div>
	       </template>
	    </el-table-column>
	    <el-table-column
	    	  
	      width="100"
	      label="value"
	       >
	       <template slot-scope="scope">
	           <div  @click="dischangeZuobiao(scope.row.value,scope.row.ids,2)">{{scope.row.value}}</div>
	       </template>
	    </el-table-column>
		
		<el-table-column
			width="200"
			label="操作"
		>
		   <template slot-scope="scope">
			 <el-row>
			   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="zuobiaoDel(scope.row.ids,scope.$index)">删除</el-col>				
			 </el-row>
		   </template>
		</el-table-column>
	</el-table>
	</template>
	  			
				
	   
	</el-dialog>
    <direction-image-dialog ref="directionImageDialog" />
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         img:'',
         names:'',
         disDialogVisible:false,
		 xuanzhuan:false,
		 xuanzhuanList:[],
		 xuan_id:0,
		 xuan_left:0,
		 xuan_right:0,
		 xuan_yiban:0,
		 xuan_ids:0,
		 xuanzhuanC:false,
		 xuan_t:0,
		 xuan_cId:0,
		 xuan_name:'',
		 
		 yidongsudu:false,
		 yidongList:[],
		 yidong_id:0,
		 yidong_sudu:0,		
		 yidong_ids:0,
		 yidongsuduC:false,
		 yidong_t:0,
		 yidong_cId:0,
		 yidong_name:'',
		 
		 
		 zuobiao:false,
		 zuobiaoList:[],
		 zuobiao_id:0,
		 zuobiao_value:0,		
		 zuobiao_ids:0,
		 zuobiaoC:false,
		 zuobiao_t:0,
		 zuobiao_cId:0,
		 zuobiao_name:'',
		 zuobiao_type:0,
		 zuobiao_title:'',
		 
		 
         changeId:0,
         t:0,
         addImg:'',
         addImgs:'',
         imageId:0,
         seachName:'',
         imgId:0,
				 
				 dialogVisiblegl:false,
				 disDialogVisiblehy:false,
				 lists:[],
				 xc_id:0,
				 textarea:'',



      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
		
	
	
	
	to(id){
	  this.$router.push({ name:'Xingxiangzhimiz', query: { id: id }})
	},  
    seach(){
      this.loadList();
    },
    
    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimiChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimi_list'
      })
      .then(res=>{

        this.list = res.data.list;
		this.count = res.data.count;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
              item['lables'] = item['lable'].split(',');
        })
        


      })
      .catch(err=>{

      });
    },




    del(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimiDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.wangzhi == ''){
        this.msg('请填写网址','error')
        return false
      }


      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/xingqiuzhimiAdd',
      	params:{
      		name:this.name,
            img:this.img,
      		

      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/xingxiangzhimi.vue